module.exports = __webpack_public_path__ + "img/custom-group-no-records.4c504dc6.png";